import { Component, Input, OnInit } from '@angular/core';
import { OrderStatusOptions, ReportTerminals, emptyFields, TransactionTypeOptions,
Country, TopupOptions, settlementStatusOptions, settlementStatusText, TransactionAccountTypeOptions,
TransactionAccountTypes, UsersType, FooterStaticValue, ReportTerminal, gstColumnName} from '../utilities/common-file';
import { NzTableData } from '../utilities/nz-table.adapter';
import { MerchantTransactionSearch } from '../models/merchant-transactions';
import { Messages } from '../utilities/message';
import { DateRange, MomentHelper } from '../models/date';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AuthService } from '../auth/auth.service';
import {countries} from '../utilities/countries';
import { DownloadService } from '../reports/download-service';
import { CommonService } from '../utilities/common-service';
import * as moment from 'moment';
import { TransactionService } from '../transactions/transactions.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-view-daily-transactions',
  templateUrl: './view-daily-transactions.component.html',
})
export class ViewDailyTransactionsComponent implements OnInit {
    transactionStatusList = OrderStatusOptions;
    transactionTypeList = TransactionTypeOptions;
    topupOptions = TopupOptions;
    reportTerminal=ReportTerminal;
    showDownload: string;
    loading = false;
    emptyField = emptyFields;
    country = Country;
    @Input()selectedTransaction: any;
    selectedRateDateRange: Date[] = null;
    agentId: any;
    countries = countries;
    downloadList = [];
    userRoles = UsersType;
    transactionAccountTypes = TransactionAccountTypes;
    accountTypeOptions = TransactionAccountTypeOptions;
    settlementStatus = settlementStatusOptions;
    textForSettlementStatus = settlementStatusText;
    totalAmount=0;
    currencySymbol='';
    totalBankFee=0; 
    totaltransactionFee=0 
    totalNetAmount=0;
    // For App Code
    showAppCodeFilter = false;
    appCodeOptions = [];
    showTotalAmount = false;
    encryptedAmount=FooterStaticValue.encryptedAmount;
    gst:any = localStorage.getItem('gst');
    hst:any = localStorage.getItem('hst');
    gstColumnName = gstColumnName;
    totalFlexmGst = 0;
    totalFlexmFee = 0;
    columnName :any;
    private tableData: NzTableData<MerchantTransactionSearch, any> = new NzTableData<MerchantTransactionSearch, any>
    (new MerchantTransactionSearch(), 'name');
  // tslint:disable-next-line: max-line-length
  constructor(private transactionService: TransactionService, private authService: AuthService,
              private drawerRef: NzDrawerRef, private notification: NzNotificationService,
              private downloadService: DownloadService, private commonService: CommonService) {
              }

  ngOnInit() {
    this.hst = (this.hst === "true");
    this.gst = (this.gst === "true");
    if(this.gst && this.hst){
      this.columnName = this.gstColumnName.hst;
      }
      if(this.gst && !this.hst){
      this.columnName = this.gstColumnName.gst;
      }
    if (this.selectedTransaction) {
        this.getReport();
    }
  }
  onUpdatedOnChange(range: any[]) {
    if (range.length <= 1) { return; }
    this.tableData.search.createdDate = MomentHelper.createDateRange(range);
    this.getReport();
  }
  updateClear(range: any[]) {
    if (range.length <= 1) {
      this.tableData.search.createdDate = DateRange.empty();
      return;
  }
  }
  getReport(startFromPageOne: boolean = true): void {
    this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    }
    // tslint:disable-next-line: radix
    this.tableData.search.merchantId = this.selectedTransaction.merchantId;
    // tslint:disable-next-line: radix
    this.tableData.search.locationId = this.selectedTransaction.locationId;
    this.tableData.search.createdDate.startDate = moment(this.selectedTransaction.transactionDate).startOf('day').toISOString();
    this.tableData.search.createdDate.endDate = moment(this.selectedTransaction.transactionDate).endOf('day').toISOString();
    this.tableData.search.accountType = [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment,
    TransactionAccountTypes.refund];
    this.transactionService.getMerchantTransactionListView(this.tableData).subscribe(
      (response: any) => {
        //  this.totalAmount=response.data.totalAmount.toFixed(2); 
        // this.totalBankFee = response.data.totalBankFee.toFixed(2);
        // this.totalNetAmount = response.data.totalNetAmount.toFixed(2);
        // this.totaltransactionFee = response.data.totalTransactionFee.toFixed(2);
        this.loading = false;
        this.tableData.total = response.data.total;
        this.tableData.data = response.data.transactions;
        this.showDownload = Messages.downloadReport;
        this.currencySymbol = this.commonService.getCurrencySymbol(this.tableData.search.appCode);
        if(startFromPageOne){this.showTotalAmount=false;}
      },
      () => {
        this.loading = false;
        this.tableData.data = [];
        this.showDownload = '';
      }
    );

}
//Footer data show
transactionSummaryTriggered(){
  this.getTransactionSummary(false);
}
getTransactionSummary(isDownload){ 
  if ((this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) || !isDownload) {
    this.transactionService.merchantTransactionSummary(this.tableData).subscribe((response: any) => {
          this.totalAmount = response.data.totalAmount.toFixed(2);
          this.totaltransactionFee=response.data.totalTransactionFee.toFixed(2);
    // this.totalBankFee=response.data.totalBankFee.toFixed(2);
    this.totalNetAmount=response.data.totalNetAmount.toFixed(2);
    // this.totalBankFee = response.data.totalBankFee.toFixed(2);
    
          this.currencySymbol = this.commonService.getCurrencySymbol(this.tableData.search.appCode); 
          if(isDownload){this.downloadExcelFromBuffer();}else{this.showTotalAmount=true;}
    }, () => {
      this.loading = false;
      this.tableData.data = [];
      this.showDownload = '';
    });
  } else {
    this.notification.error(Messages.noDateSelected, '', {
      nzKey: 'key'
    });
  }
}


onIndexChange(event) {
  this.tableData.pageIndex = event;
  this.getReport(false);
}
getTransactionType(mode) {
  return this.commonService.getTransactionAccountType(mode);
}
// tslint:disable-next-line: indent
getColorForTransactionType(mode) {
  return this.commonService.getColorForTransactionAccountType(mode);
}
getCurrency(currency) {
  const index = this.countries.findIndex(M => M.currency_code ===  currency);
  if (index !== -1) {
      return this.countries[index].currency_symbol;
  }
}
downloadReport() {
  this.notification.info('Download Processing', 'Please Wait', {
    nzKey : 'key'
  });
  const value = {
    startDate: this.tableData.search.createdDate.startDate ? this.tableData.search.createdDate.startDate : '',
    endDate: this.tableData.search.createdDate.endDate ? this.tableData.search.createdDate.endDate : '',
    transactionStatus: this.tableData.search.transactionStatus,
    transactionType: this.tableData.search.transactionType,
    settlementStatus: this.tableData.search.settledStatus,
    isSettled: this.tableData.search.isSettled,
    accountTypeIn: this.tableData.search.accountType ? this.tableData.search.accountType :
    [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes.settlement,
   TransactionAccountTypes.refund],
    mobileNo: this.tableData.search.type === 'mobile_no' ? this.tableData.search.number  : '',
    accountNo: this.tableData.search.type === 'account_no' ? this.tableData.search.number  : '',
    // tslint:disable-next-line: radix
    id: this.tableData.search.id ? parseInt(this.tableData.search.id) : '',
    name: this.tableData.search.name,
    merchantId: parseInt(this.authService.getMerchantId()),
    locationId: this.tableData.search.locationId ? this.tableData.search.locationId : '',
  };
     // For Footer 
     const gridFooter = ['Total Amount','Total Transaction Fee','Total Net Amount'];
     const footerData=[
        this.currencySymbol+this.totalAmount,
      //  this.currencySymbol+this.totalBankFee,
       this.currencySymbol+this.totaltransactionFee,
       this.currencySymbol+this.totalNetAmount
     ];
  this.transactionService.downloadMerchantTransactionReportNew(value).subscribe((response: any) => {
    this.downloadList = response.data.transactions;
    if (this.downloadList.length > 0) {
      const headers = ['Transaction ID', 'Account No', 'Mobile No', 'Display Name', 'Location Name',
      'Transaction Amount', 'Transaction Fee', 'Net Amount Transferred',
      'Transaction Type', 'Narration', 'Created Date', 'Created By'];
      // tslint:disable-next-line: max-line-length
      this.downloadService.onDownloadExcel(headers, ReportTerminals.merchantTransactionsForSummary,
      this.tableData.search.createdDate.startDate, this.tableData.search.createdDate.endDate, this.downloadList,
      ReportTerminals.merchantTransactionsForSummary,
      ReportTerminals.merchantTransactionsForSummary,'','',gridFooter,footerData);
    }
  });
}
downloadExcelFromBuffer(){
  if (this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) {
    this.notification.info('Download Processing', 'Please Wait', {
      nzKey : 'key'
    });
    const value = {
      startDate: this.tableData.search.createdDate.startDate ? this.tableData.search.createdDate.startDate : '',
      endDate: this.tableData.search.createdDate.endDate ? this.tableData.search.createdDate.endDate : '',
      transactionStatus: this.tableData.search.transactionStatus,
      transactionType: this.tableData.search.transactionType,
      settlementStatus: this.tableData.search.settledStatus,
      isSettled: this.tableData.search.isSettled,
      accountTypeIn: this.tableData.search.accountType ? this.tableData.search.accountType :
      [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes.settlement,
     TransactionAccountTypes.refund],
      mobileNo: this.tableData.search.type === 'mobile_no' ? this.tableData.search.number  : '',
      accountNo: this.tableData.search.type === 'account_no' ? this.tableData.search.number  : '',
      // tslint:disable-next-line: radix
      id: this.tableData.search.id ? parseInt(this.tableData.search.id) : '',
      name: this.tableData.search.name,
      merchantId: parseInt(this.authService.getMerchantId()),
      locationId: this.tableData.search.locationId ? this.tableData.search.locationId : '',
    isBufferData:true,
    reportTerminal:this.reportTerminal.MerchantTransactionsDailySummary
    };
    this.transactionService.downloadMerchantTransactionReportNew(value).subscribe((response: any) => {
      this.downloadList = response.data.data;
      // this.downloadList = response.data.data;
      const bufferArray = new Uint8Array(response.data.data.data);
      const blob = new Blob([bufferArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const reader = new FileReader();
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
        const data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
        // Provide an option for the user to download the Excel file
        const blobForDownload = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blobForDownload);
        const a = document.createElement('a');
        a.href = url;
        const fileNameForFile = ReportTerminals.merchantTransactionsForSummary + '_' + moment().format('DDMMYYYYhhmmss') + '.xlsx';
        a.download = fileNameForFile
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        this.notification.remove('key');
      };
      reader.readAsArrayBuffer(blob);
    });
  } else {
    this.notification.error(Messages.noDateSelected, '', {
      nzKey : 'key'
    });
  }
}
close() {
    this.drawerRef.close();
}
}
